function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.4 13.043l-.585-.579a2.904 2.904 0 00-.533-3.405L9.268 5.073l.909-.902a.883.883 0 00.193-.964.883.883 0 00-.193-.286L7.702.464a.891.891 0 00-.971-.192.89.89 0 00-.289.192l-.94.932-.547-.543A2.954 2.954 0 00.862.793l-.01.01L.8.853a.93.93 0 00-.078.092 2.903 2.903 0 00.14 3.978l.545.542-.94.927a.883.883 0 00-.193.964c.044.108.11.205.193.287L2.942 10.1a.892.892 0 001.26 0l.91-.903 4.016 3.989a2.92 2.92 0 003.418.519l.593.589a.894.894 0 001.26 0 .881.881 0 000-1.251zM2.123 3.668a1.142 1.142 0 01-.022-1.601 1.164 1.164 0 011.593.037l.546.543-1.57 1.56-.547-.539zm1.447 4.56l-1.214-1.21.94-.93L6.13 3.274l.94-.935 1.214 1.205L3.57 8.227zm6.816 3.71l-4.013-3.99 1.634-1.625 4.015 3.986a1.147 1.147 0 01.252 1.252c-.059.14-.144.266-.252.372a1.19 1.19 0 01-1.636.002v.004z"
});

var SvgPicker = function SvgPicker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picker.7bebdaeb.svg";
export { ForwardRef as ReactComponent };